import React from 'react'
import styled from '@emotion/styled'

import { ListItemButton, Menu, MenuItem, Typography } from '@mui/material'
import { Assessment as AssessmentIcon } from '@mui/icons-material'

import useJasperUrl from '../../../Hooks/useJasperUrl'
import { Site } from '../../../../generated/graphql'
import globalAuctionStore from '../../../../modules/auction/store/globalAuctionStore'
import useAuctionId from '../../../Hooks/useAuctionId'

export const ListItem = styled.div`
    display: flex;
    padding: 10px;
    flex-direction: row;
    color: gray;
    align-items: center;
    justify-content: space-between;

    &.hoverIndex:hover {
        border-radius: 0px 50px 50px 0px;
        transition: 0.1s ease all;
        color: #009688;
        background: whitesmoke;
    }
`

const JasperLink = () => {
    const auctionId = useAuctionId()
    const link = useJasperUrl(auctionId)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [isHovered, setIsHovered] = React.useState(false)

    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const handleIconHoverColor = () => {
        setIsHovered(!isHovered)
    }
    const auctionSites = globalAuctionStore((s) => s.auctionSites)

    const AuctionSiteItem = ({ site }: { site: Site | null | undefined }) => {
        const siteLink = useJasperUrl(site?.biCode || '')

        return (
            <a href={siteLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <MenuItem onClick={handleClose}>{site?.locationName}</MenuItem>
            </a>
        )
    }

    if (auctionSites?.filter((s) => s?.biCode).length) {
        return (
            <>
                <ListItemButton
                    id="action_sites_menu"
                    onClick={handleClick}
                    onMouseEnter={handleIconHoverColor}
                    onMouseLeave={handleIconHoverColor}
                >
                    <AssessmentIcon sx={{ paddingLeft: '5px', color: isHovered ? '#009688' : 'grey' }} />
                    <Typography
                        sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '25px', width: '100%' }}
                        variant="body2"
                    >
                        B.I.
                    </Typography>
                </ListItemButton>

                <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {auctionSites.map((site) => (
                        <AuctionSiteItem key={site?.pipelineCode} site={site} />
                    ))}
                </Menu>
            </>
        )
    } else {
        return (
            <a href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <ListItem className="hoverIndex">
                    <AssessmentIcon sx={{ paddingLeft: '10px' }} />
                    <Typography
                        sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '25px', width: '100%' }}
                        variant="body2"
                    >
                        B.I.
                    </Typography>
                </ListItem>
            </a>
        )
    }
}
export default JasperLink
